import React, { useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import { useNavigate } from 'react-router-dom';  
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import leftarrow from '../../../safreeimg/left-arrow.png'

const NewCoupon = () => {
  const [couponCode, setCouponCode] = useState('');
  const [offerPercentage, setOfferPercentage] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();  

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Validation check before sending API request
    if (!couponCode.trim() || !offerPercentage || !description.trim()) {
      alert("All fields are required!");
      return;
    }
  
    try {
      setLoading(true);
      setError(null);
  
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }
  
      const response = await axios.post(
        'https://api.safree.org/api-v2022/superAdmin/auth/v1/create/coupons',
        { couponCode, offerPercentage, description },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      if (response.data.success) {
        setCouponCode('');
        setOfferPercentage('');
        setDescription('');
        alert('Coupon created successfully!');
      } else {
        setError('Failed to create coupon');
      }
    } catch (err) {
      setError('An error occurred while creating coupon: ' + err.message);
    } finally {
      setLoading(false);
    }
  };  
  const handleBackClick = () => {
    navigate(-1);  
  };
  if (loading) return <div className='loading'><img src={Loader} alt="Loading" /></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-12">
          <p className="sub-heading"> <img  onClick={handleBackClick} className="back-button" src={leftarrow} alt="" />Create Coupon</p>
        </div>
      </div>

      <div className="row">
        <div className='col-md-2'></div>
        <div className="col-md-8">
          <div className="form-container createcoupen">
            <form className="styled-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="couponCode">Enter Your Coupon Code</label>
                <input
                  type="text"
                  id="couponCode"
                  className="form-control"
                  placeholder="Enter Code"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="offerPercentage">Select Discount</label>
                <select
                  id="offerPercentage"
                  className="form-control"
                  value={offerPercentage}
                  onChange={(e) => setOfferPercentage(e.target.value)}
                >
                  <option value="">Select Discount</option>
                  {[...Array(20)].map((_, i) => {
                    const value = (i + 1) * 5;
                    return (
                      <option key={value} value={value}>
                        {value}%
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="description">Enter Description</label>
                <textarea
                  id="description"
                  className="form-control"
                  placeholder="Enter Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>

              <button type="submit" className="btn btn-submit">Generate</button>
            </form>
          </div>
        </div>
        <div className='col-md-2'></div>
      </div>
    </div>
  );
};

export default NewCoupon;